

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import {RegisterUser} from "@/models/registerUser";
import {AccountPermission} from "@/models/accountPermission";
import {DichVuCreate} from "@/models/dichVuCreate";
import {DichVu} from "@/models/dichVu";
import moment from 'moment';
import {FilterMatchMode} from "primevue/api";
import {LieuTrinhCreate} from "@/models/lieuTrinhCreate";
import {LieuTrinh} from "@/models/lieuTrinh";
import {SanPhamCreate} from "@/models/sanPhamCreate";
import {SanPham} from "@/models/sanPham";
import {KhachHangCreate} from "@/models/khachHangCreate";
import {KhachHang} from "@/models/khachHang";
import {ThanhPhan} from "@/models/thanhPhan";
import { useConfirm } from "primevue/useconfirm";
import {HoaDonCreate} from "@/models/hoaDonCreate";
import {HoaDon} from "@/models/hoaDon";
import {HoaDonDetail} from "@/models/hoaDonDetail";
import {DoanhThu} from "@/models/doanhThu";
import {LichSuLieuTrinh} from "@/models/lichSuLieuTrinh";
import {ThucHienLieuTrinhCreate} from "@/models/thucHienLieuTrinhCreate";
import {Debt} from "@/models/debt";
import {ThanhPhanDetail} from "@/models/thanhPhanDetail";
import {HoaDonUpdate} from "@/models/hoaDonUpdate";


export default {

  setup(){
    const confirm = useConfirm();
    const router = useRouter();
    const listThanhPhan = ref([] as ThanhPhan[]);
    const listDichVu = ref([] as DichVu[]);
    const listLieuTrinh = ref([] as LieuTrinh[]);
    const listSanPham = ref([] as SanPham[]);
    const dichVu = ref({} as DichVu);
    const soLuongDV = ref(1);
    const idLieuTrinh = ref(0);
    const lieuTrinh = ref({} as LieuTrinh);
    const soLuongLT = ref(1);
    const idSanPham = ref(0);
    const sanPham = ref({} as SanPham);
    const soLuongSP = ref(1);
    const tongTien = ref(0);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const giamPhanTram = ref(0);
    const giamGia = ref(0);
    const tongThucThu = ref(0);
    const traTruoc = ref(0);
    const conLai = ref(0);
    const confirmTransaction = ref(false);
    const khachHang = ref({} as KhachHang);
    const listKhachHang = ref([] as KhachHang[]);
    const date = ref();
    const dateLT = ref();
    const dateThucHien = ref();
    const listHoaDon = ref([] as HoaDonDetail[]);
    const listLichSuLieuTrinh = ref([] as LichSuLieuTrinh[]);
    const doanhThu = ref({} as DoanhThu);
    const thucHienLieuTrinhCreate = ref({} as ThucHienLieuTrinhCreate);
    const showDoanhThu = ref(false);
    const showThucHienLT = ref(false);
    const showHoaDonDetail = ref(false);
    const showThanhPhanDetailMore = ref(false);
    const showThanhPhanDetail = ref(false);
    const showUpdateHoaDon = ref(false);
    if (!!!store.state.token) {
      router.push({ name: "home" });
    }
    const debt = ref({} as Debt);
    const listThanhPhanDetail = ref([] as ThanhPhanDetail[]);
    const listThanhPhanDetailMore = ref([] as ThanhPhanDetail[]);
    const listHoaDonShow = ref([] as HoaDonDetail[]);
    const hoaDonIdDetail = ref(0);
    const hoaDonUpdate = ref({} as HoaDonUpdate);


    const getListKhachHang = () => {
      AuthRepository.getListKhachHang()
          .then((response) => {
            listKhachHang.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const getDebt = () => {
      console.log("######################### getDebt khachHang: " + JSON.stringify(khachHang.value));

      AuthRepository.getDebt(khachHang.value.id)
          .then((response) => {
            debt.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const getListHoaDonByKhachHang = () => {
      AuthRepository.getListHoaDonByKhachHang(khachHang.value.id)
          .then((response) => {
            listHoaDonShow.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const getListThanhPhan = (id) => {
      AuthRepository.getListThanhPhan(id)
          .then((response) => {
            listThanhPhanDetail.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const getListThanhPhanMore = (id) => {
      AuthRepository.getListThanhPhan(id)
          .then((response) => {
            listThanhPhanDetailMore.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    getListKhachHang();



    const tinhTien = () => {
      console.log('################@@@@@@@@@@@@@@@ tinhTien giamPhanTram.value: ' + giamPhanTram.value);
      console.log('################@@@@@@@@@@@@@@@ tinhTien giamGia.value: ' + giamGia.value);
      tongThucThu.value = tongTien.value - (tongTien.value * giamPhanTram.value)/100 - giamGia.value;
      console.log('################@@@@@@@@@@@@@@@ tinhTien tongThucThu.value: ' + tongThucThu.value);
    };
    // const validKhachHang = computed(()=>  khachHangCreate.value.tenKhachHang && khachHangCreate.value.diaChi  && khachHangCreate.value.soDienThoai?.length >=10 && khachHangCreate.value.ngaySinh );

    const generateId = (): string => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    };
    const getListDichVu = () => {
      AuthRepository.getListDichVu()
          .then((response) => {
            listDichVu.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const createMuaDichVu = () => {
      const hoaDonCreate = ref({} as HoaDonCreate);
      const hoaDon = ref({} as HoaDon);
      hoaDonCreate.value.idKhachHang = khachHang.value.id; // set default
      hoaDonCreate.value.giaBan = tongTien.value;
      hoaDonCreate.value.giamGia = giamGia.value;
      hoaDonCreate.value.giaThucThu = tongThucThu.value;
      hoaDonCreate.value.soTienDaThu = traTruoc.value;
      hoaDonCreate.value.soTienNo = conLai.value;
      AuthRepository.checkThanhPhan(listThanhPhan.value)
          .then((response) => {
            AuthRepository.createHoaDon(hoaDonCreate.value)
                .then((response) => {
                  hoaDon.value = response.data;
                  listThanhPhan.value.forEach(x =>
                      {
                        x.idHoaDon = hoaDon.value.id;
                        x.idKhachHang = khachHang.value.id; //set default
                      }
                  )
                  AuthRepository.createThanhPhan(listThanhPhan.value)
                      .then((response) => {
                        confirmTransaction.value = false;
                        const temp = ref([] as ThanhPhan[]);
                        listThanhPhan.value = temp.value;
                        tongTien.value = 0;
                        giamPhanTram.value = 0;
                        giamGia.value = 0;
                        tongThucThu.value = 0;
                        traTruoc.value = 0;
                        conLai.value = 0;
                        toast.add({
                          severity: 'success',
                          summary: 'Thành công',
                          detail:'Đã ghi nhận dữ liệu',
                          life: 4000
                        });
                      })
                      .catch(err => {
                        toast.add({
                          severity: 'error',
                          summary: 'Lỗi',
                          detail:err.response.data,
                          life: 3000
                        });
                      });
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 3000
                  });
                });
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 3000
            });
          });
    }

    const changeDichVu = () => {
      listDichVu.value.forEach(x =>
          {
            if(dichVu.value.id == x.id){
              dichVu.value.giaThucThu = x.giaThucThu;
              dichVu.value.tenDichVu = x.tenDichVu;
              dichVu.value.giaThucThu = x.giaThucThu;
              dichVu.value.giaBan = x.giaBan;
              dichVu.value.giamGia = x.giamGia;
            }
          }
      )
    }

    const addDichVu = () => {
      const temp = ref({} as ThanhPhan);
      temp.value.tenThanhPhan = dichVu.value.tenDichVu;
      temp.value.loaiThanhPhan = 'Dịch vụ';
      temp.value.maThanhPhan = 'DichVu';
      temp.value.giaThucThu = dichVu.value.giaThucThu;
      temp.value.giaBan = dichVu.value.giaBan;
      temp.value.soLuong = soLuongDV.value;
      temp.value.tongTien = soLuongDV.value * dichVu.value.giaThucThu;
      temp.value.idThanhPhan = dichVu.value.id;
      temp.value.giamGia = dichVu.value.giamGia;
      temp.value.id = generateId();
      listThanhPhan.value.push(temp.value);
      tongTien.value = tongTien.value + temp.value.tongTien;
      tinhTien();
      var reset = ref({} as DichVu);
      dichVu.value =  reset.value;
      soLuongDV.value = 1;
      console.log('################@@@@@@@@@@@@@@@ selectDichVu listThanhPhan: ' + JSON.stringify(listThanhPhan.value));
    }
    const changeSanPham = () => {
      listSanPham.value.forEach(x =>
          {
            if(sanPham.value.id == x.id){
              sanPham.value.giaThucThu = x.giaThucThu;
              sanPham.value.tenSanPham = x.tenSanPham;
              sanPham.value.giaThucThu = x.giaThucThu;
              sanPham.value.giaBan = x.giaBan;
              sanPham.value.giamGia = x.giamGia;
            }
          }
      )
    }

    const addSanPham = () => {
      const temp = ref({} as ThanhPhan);
      temp.value.tenThanhPhan = sanPham.value.tenSanPham;
      temp.value.loaiThanhPhan = 'Sản phẩm';
      temp.value.maThanhPhan = 'SanPham';
      temp.value.giaThucThu = sanPham.value.giaThucThu;
      temp.value.giaBan = sanPham.value.giaBan;
      temp.value.soLuong = soLuongSP.value;
      temp.value.tongTien = soLuongSP.value * sanPham.value.giaThucThu;
      temp.value.idThanhPhan = sanPham.value.id;
      temp.value.giamGia = sanPham.value.giamGia;
      temp.value.id = generateId();
      listThanhPhan.value.push(temp.value);
      tongTien.value = tongTien.value + temp.value.tongTien;
      tinhTien();
      var reset = ref({} as SanPham);
      sanPham.value =  reset.value;
      soLuongSP.value = 1;
      console.log('################@@@@@@@@@@@@@@@ selectDichVu listThanhPhan: ' + JSON.stringify(listThanhPhan.value));
    }
    const changeLieuTrinh = () => {
      listLieuTrinh.value.forEach(x =>
          {
            if(lieuTrinh.value.id == x.id){
              lieuTrinh.value.giaThucThu = x.giaThucThu;
              lieuTrinh.value.tenLieuTrinh = x.tenLieuTrinh;
              lieuTrinh.value.giaThucThu = x.giaThucThu;
              lieuTrinh.value.giaBan = x.giaBan;
              lieuTrinh.value.giamGia = x.giamGia;
            }
          }
      )
    }

    const addLieuTrinh  = () => {
      const temp = ref({} as ThanhPhan);
      temp.value.tenThanhPhan = lieuTrinh.value.tenLieuTrinh;
      temp.value.loaiThanhPhan = 'Liệu trình';
      temp.value.maThanhPhan = 'LieuTrinh';
      temp.value.giaThucThu = lieuTrinh.value.giaThucThu;
      temp.value.giaBan = lieuTrinh.value.giaBan;
      temp.value.soLuong = soLuongLT.value;
      temp.value.tongTien = soLuongLT.value * lieuTrinh.value.giaThucThu;
      temp.value.idThanhPhan = lieuTrinh.value.id;
      temp.value.giamGia = lieuTrinh.value.giamGia;
      temp.value.id = generateId();
      listThanhPhan.value.push(temp.value);
      tongTien.value = tongTien.value + temp.value.tongTien;
      tinhTien();
      var reset = ref({} as LieuTrinh);
      lieuTrinh.value =  reset.value;
      soLuongLT.value = 1;
      console.log('################@@@@@@@@@@@@@@@ selectDichVu listThanhPhan: ' + JSON.stringify(listThanhPhan.value));
    }
    const getListLieuTrinh= () => {
      AuthRepository.getListLieuTrinh()
          .then((response) => {
            listLieuTrinh.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 3000
            });
          });
    }
    const getListSanPham = () => {
      AuthRepository.getListSanPham()
          .then((response) => {
            listSanPham.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 3000
            });
          });
    }

    getListDichVu();
    getListLieuTrinh();
    getListSanPham();

    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return ""
      }
      else
        return moment(String(date)).format(' DD/MM/YYYY');
    };
    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatCurrency = (money) => {
      // Use Intl.NumberFormat to format the number as currency
      const formatter = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0, // Set the number of decimal places you want
      });
      if(money > 0) {
        return formatter.format(money);
      }
      else
      {
        return '';
      }
    };

    const tongTienFormatted = computed(() => {
      return formatCurrency(tongTien.value);
    });
    const deleteThanhPhan = (item: ThanhPhan) => {
      listThanhPhan.value = listThanhPhan.value.filter(
          x => x.id !== item.id
      );

       tongTien.value -= item.tongTien;
      tongThucThu.value = tongTien.value;
    };


    const confirmDelete = (event, item: ThanhPhan) => {
      confirm.require({
        target: event.currentTarget,
        message: 'Vui lòng xác nhận lại việc xóa?',
        icon: 'pi pi-exclamation-triangle',

        acceptClass: 'spa-confirm-accept',
        rejectClass: 'spa-confirm-reject',

        acceptLabel: 'Có',
        rejectLabel: 'Không',

        accept: () => {
          listThanhPhan.value = listThanhPhan.value.filter(
              x => x.id !== item.id
          );
          tongTien.value -= item.tongTien;
          tinhTien();

          toast.add({
            severity: 'info',
            summary: 'Xác nhận',
            detail: 'Xóa thành công',
            life: 3000
          });
        }
      });
    };




    const clickXuLy= () => {
      confirmTransaction.value = true;
      traTruoc.value = tongThucThu.value;
    }

    const clickTraTruoc = () => {
      conLai.value = tongThucThu.value - traTruoc.value;
    }

    const clickTraTruocUpdate = () => {
      hoaDonUpdate.value.soTienNo = hoaDonUpdate.value.giaThucThu - hoaDonUpdate.value.soTienDaThu;
    }

    const clickThanhToan = () => {
      toast.add({ severity: 'info', summary: 'Xác nhận', detail: 'Thanh toán thành công '+conLai.value , life: 6000 });
    }

    const clickShowTienNo = () => {
      showHoaDonDetail.value =true;
    }

    const ngayMuaHang = ref('');
    const clickShowChiTiet = (id: number,date: Date) => {
      ngayMuaHang.value = '';
      showThanhPhanDetail.value =true;
      getListThanhPhan(id);
      ngayMuaHang.value  = 'Chi tiết mua hàng (' + formatDateTime(date) +')';
    }

    const clickShowChiTietMore = (id: number,date: Date) => {
      ngayMuaHang.value = '';
      showThanhPhanDetailMore.value =true;
      getListThanhPhanMore(id);
      ngayMuaHang.value  = 'Chi tiết mua hàng (' + formatDateTime(date) +')';
    }


    const clearCalendar = () => {
      console.log("@@@@@@@@@################ clearDate");
      date.value = new Date();
      listHoaDon.value = [];
    }

    const selectCalendar = () => {
      if((date.value[0] != null)&&(date.value[1] != null)){
        AuthRepository.getListHoaDon(date.value[0]/1000, date.value[1]/1000,khachHang.value.id )
            .then((response) => {
              listHoaDon.value = response.data;
              AuthRepository.getDoanhThu(listHoaDon.value)
                  .then((response) => {
                    doanhThu.value = response.data;
                  })
                  .catch(err => {
                    // toast.add({
                    //   severity: 'error',
                    //   summary: 'Lỗi',
                    //   detail:err.response.data,
                    //   life: 2000
                    // });
                  });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: 'Không tìm thấy dữ liệu trong khoảng thời gian lựa chọn',
                life: 3000
              });
            });
      }
    }

    const selectCalendarLT = () => {
      if((dateLT.value[0] != null)&&(dateLT.value[1] != null)&&khachHang.value.id > 0){
        AuthRepository.getListLichSuLieuTrinh(dateLT.value[0]/1000, dateLT.value[1]/1000,khachHang.value.id )
            .then((response) => {
              listLichSuLieuTrinh.value = response.data;
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: 'Không tìm thấy dữ liệu trong khoảng thời gian lựa chọn',
                life: 3000
              });
            });
      }
    }
    const selectCalendarLTDefault = () => {
      if(khachHang.value.id > 0) {
        AuthRepository.getListLichSuLieuTrinh(0, 0, khachHang.value.id)
            .then((response) => {
              listLichSuLieuTrinh.value = response.data;
            })
            .catch(err => {
              // toast.add({
              //   severity: 'error',
              //   summary: 'Lỗi',
              //   detail: 'Không tìm thấy dữ liệu trong khoảng thời gian lựa chọn',
              //   life: 2000
              // });
            });
      }
    }

    const changeKhachHang = () => {
      console.log("######################### changeKhachHang");
      console.log("######################### changeKhachHang khachHang: " + JSON.stringify(khachHang.value));
      const temp = ref([] as ThanhPhan[]);
      listThanhPhan.value = temp.value;
      tongTien.value = 0;
      giamPhanTram.value = 0;
      giamGia.value = 0;
      tongThucThu.value = 0;
      traTruoc.value = 0;
      conLai.value = 0;
      clearCalendar();
      const tempTH = ref({} as ThucHienLieuTrinhCreate);
      thucHienLieuTrinhCreate.value = tempTH.value;
      listLichSuLieuTrinh.value = [];
      tongSoLanTH.value = 0;
      soLanTH.value = 0;

      const tempDebt = ref({} as Debt);
      debt.value = tempDebt.value;
      listThanhPhanDetail.value = [];
      listHoaDonShow.value = [];
      hoaDonIdDetail.value = 0;

      if(khachHang.value.id != null) {
        selectCalendarLTDefault();
        getDebt();
        getListHoaDonByKhachHang();
      }
    }

    const clickDoanhThu = () => {
      showDoanhThu.value = true;
    }
    const tongSoLanTH = ref(0);
    const soLanTH = ref(0);
    const clickThucHienLT = (id) => {
      showThucHienLT.value = true;
      listLichSuLieuTrinh.value.forEach(x => {
        if(x.idMuaLieuTrinh == id){
          thucHienLieuTrinhCreate.value.tenLieuTrinh = x.tenLieuTrinh;
          thucHienLieuTrinhCreate.value.idKhachHang = khachHang.value.id; // set default
          thucHienLieuTrinhCreate.value.idLieuTrinh = x.idLieuTrinh;
          thucHienLieuTrinhCreate.value.idMuaLieuTrinh = x.idMuaLieuTrinh;
          thucHienLieuTrinhCreate.value.soLuong = 1;
          tongSoLanTH.value = x.tongSoLanThucHien;
          soLanTH.value = x.soLanThucHien;
        }
      })
    }
    const clickUpdateHoaDon = (id) => {
      showUpdateHoaDon.value = true;
      listHoaDon.value.forEach(x => {
        if(x.id == id)
        {
          hoaDonUpdate.value.id = x.id;
          hoaDonUpdate.value.giaBan = x.giaBan;
          hoaDonUpdate.value.giamGia = x.giamGia;
          hoaDonUpdate.value.giaThucThu = x.giaThucThu;
          hoaDonUpdate.value.soTienDaThu = x.soTienDaThu;
          hoaDonUpdate.value.soTienNo = x.soTienNo;
        }
      })
    }

    const createThucHienLieuTrinh = () => {
      console.log("######################### createThucHienLieuTrinh");
      console.log("######################### createThucHienLieuTrinh thucHienLieuTrinhCreate: " + JSON.stringify(thucHienLieuTrinhCreate.value));
      if(dateThucHien.value != null){
        thucHienLieuTrinhCreate.value.thoiGianThucHien = dateThucHien.value;
      }
      if(soLanTH.value + thucHienLieuTrinhCreate.value.soLuong > tongSoLanTH.value){
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail: 'Số lần vượt quá giới hạn liệu trình',
          life: 3000
        });
      }
      else {
        AuthRepository.createThucHienLieuTrinh(thucHienLieuTrinhCreate.value)
            .then((response) => {
              toast.add({
                severity: 'success',
                summary: 'Thực hiện',
                detail: 'Đã thực hiện liệu trình thành công',
                life: 3000
              });
              tongSoLanTH.value = 0;
              soLanTH.value = 0;
              if (dateLT.value != null) {
                selectCalendarLT();
              } else {
                selectCalendarLTDefault();
              }
              const temp = ref({} as ThucHienLieuTrinhCreate);
              thucHienLieuTrinhCreate.value = temp.value;
              showThucHienLT.value = false;
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 3000
              });
            });
      }
    }
    const validThucHienLT = computed(()=>  thucHienLieuTrinhCreate.value.soLuong > 0);

    const updateHoaDon = () => {
      if(hoaDonUpdate.value.soTienDaThu > hoaDonUpdate.value.giaThucThu){
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail: 'Số tiền đã thu lớn hơn tổng giá trị hóa đơn',
          life: 3000
        });
      }
      else {
        AuthRepository.updateHoaDon(hoaDonUpdate.value)
            .then((response) => {
              const tempDebt = ref({} as Debt);
              debt.value = tempDebt.value;
              listThanhPhanDetail.value = [];
              listHoaDonShow.value = [];
              hoaDonIdDetail.value = 0;
              getDebt();
              getListHoaDonByKhachHang();
              selectCalendar();
              showUpdateHoaDon.value = false;
              toast.add({
                severity: 'success',
                summary: 'Thành công',
                detail: 'Hóa đơn đã được cập nhật thành công',
                life: 3000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 3000
              });
            });
      }
    }

    return {
      error,
      formatDateTime,
      filters,
      clearFilter,
      initFilters,
      formatCurrency,
      listThanhPhan,
      listDichVu,
      listLieuTrinh,
      listSanPham,
      dichVu,
      soLuongDV,
      idLieuTrinh,
      soLuongLT,
      idSanPham,
      soLuongSP,
      changeDichVu,
      lieuTrinh,
      sanPham,
      changeSanPham,
      changeLieuTrinh,
      addDichVu,
      addLieuTrinh,
      addSanPham,
      tongTien,
      deleteThanhPhan,
      tongTienFormatted,
      confirmDelete,
      giamPhanTram,
      giamGia,
      tongThucThu,
      tinhTien,
      clickThanhToan,
      confirmTransaction,
      clickXuLy,
      traTruoc,
      clickTraTruoc,
      conLai,
      createMuaDichVu,
      khachHang,
      listKhachHang,
      changeKhachHang,
      listHoaDon,
      selectCalendar,
      clearCalendar,
      date,
      doanhThu,
      showDoanhThu,
      clickDoanhThu,
      selectCalendarLT,
      dateLT,
      listLichSuLieuTrinh,
      createThucHienLieuTrinh,
      thucHienLieuTrinhCreate,
      showThucHienLT,
      clickThucHienLT,
      dateThucHien,
      validThucHienLT,
      debt,
      clickShowTienNo,
      listHoaDonShow,
      listThanhPhanDetail,
      showHoaDonDetail,
      clickShowChiTiet,
      showThanhPhanDetail,
      ngayMuaHang,
      clickUpdateHoaDon,
      showUpdateHoaDon,
      hoaDonUpdate,
      clickTraTruocUpdate,
      updateHoaDon,
      clickShowChiTietMore,
      showThanhPhanDetailMore,
      listThanhPhanDetailMore,
    }
  }
}

